// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px) and (min-width: 601px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "passengers-21KOD";
var _5 = "passengers_isMultiCity-1bhwM";
var _6 = "selector-Mlj0-";
var _7 = "menu-22D-R";
var _8 = "mobileTitle-LnWFO";
var _9 = "alternative-G_8zq";
var _a = "title-2Wi74";
export { _1 as "__esModule", _2 as "tablet_only", _3 as "mobile", _4 as "passengers", _5 as "passengers_isMultiCity", _6 as "selector", _7 as "menu", _8 as "mobileTitle", _9 as "alternative", _a as "title" }
export default { "__esModule": _1, "tablet_only": _2, "mobile": _3, "passengers": _4, "passengers_isMultiCity": _5, "selector": _6, "menu": _7, "mobileTitle": _8, "alternative": _9, "title": _a }
